import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { Dropdown, IDropdownItem } from './Dropdown';
import { IStore } from '../../domain/store';
import { IUsecase } from '../../application/usecase';
import { ExperienceStateType, RoundPurposeType, TargetDeviceType } from '../../domain/entity/PortfolioReportItem';

interface IProps {
  store?: IStore;
  usecase?: IUsecase;
}

const TriggerButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  min-width: 38px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid ${colors.lithium_light__e2e6ef};
  border-radius: 4px;
  color: currentColor;
  outline: none;
  font-size: 1rem;
  padding: 0;
`;

const TriggerButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
`;

const FilterItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;

  & input {
    margin-right: 16px;
  }

  & label {
    width: 100%;
    padding: 6px 0;
  }
`;

const CurrentFilter = styled.div`
  & + &:before {
    content: ', ';
  }
  &:last-child {
    margin-right: 12px;
  }
`;

interface IFilter {
  id: TargetDeviceType | ExperienceStateType | RoundPurposeType;
  label: string;
  type: 'targetDeviceFilter' | 'stateFilter' | 'roundPurposeFilter';
}

const Filters: IFilter[] = [
  {
    id: 'pc',
    label: 'PC向け',
    type: 'targetDeviceFilter',
  },
  {
    id: 'mobile',
    label: 'スマートフォン向け',
    type: 'targetDeviceFilter',
  },
  {
    id: 'competition',
    label: '実施中',
    type: 'stateFilter',
  },
  {
    id: 'research',
    label: '探索ラウンド中',
    type: 'roundPurposeFilter',
  },
  {
    id: 'use',
    label: '活用ラウンド中',
    type: 'roundPurposeFilter',
  },
  {
    id: 'initial',
    label: '準備中',
    type: 'stateFilter',
  },
  {
    id: 'interim',
    label: 'インターバル',
    type: 'stateFilter',
  },
  {
    id: 'archived',
    label: '終了',
    type: 'stateFilter',
  },
];

@inject('store', 'usecase')
@observer
export class FilterMenu extends React.Component<IProps, {}> {
  private store: IStore;
  private usecase: IUsecase;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.usecase = props.usecase!;
    this.stopPropagation = this.stopPropagation.bind(this);
    this.changeFilterCondition = this.changeFilterCondition.bind(this);
  }

  private stopPropagation(e: React.SyntheticEvent<HTMLElement>) {
    e.stopPropagation();
  }

  public changeFilterCondition(e: React.SyntheticEvent<HTMLElement>) {
    const { portfolioReportUsecase } = this.usecase;
    const target = e.target as HTMLInputElement;
    if (target.name === 'targetDeviceFilter') {
      portfolioReportUsecase.updateTargetDeviceFilter(target.value as TargetDeviceType);
    }
    if (target.name === 'stateFilter') {
      portfolioReportUsecase.updateStateFilter(target.value as ExperienceStateType);
    }
    if (target.name === 'roundPurposeFilter') {
      portfolioReportUsecase.updateRoundPurposeFilter(target.value as RoundPurposeType);
    }
  }

  private createFilterItemComponent(filter: IFilter) {
    const { portfolioReportStore } = this.store;
    return (
      <FilterItem>
        <label>
          <input
            type="checkbox"
            name={filter.type}
            value={filter.id}
            onChange={this.changeFilterCondition}
            checked={
              filter.type === 'targetDeviceFilter'
                ? portfolioReportStore.targetDeviceFilters.includes(filter.id as TargetDeviceType)
                : filter.type === 'stateFilter'
                  ? portfolioReportStore.stateFilters.includes(filter.id as ExperienceStateType)
                  : filter.type === 'roundPurposeFilter'
                    ? portfolioReportStore.roundPurposeFilters.includes(filter.id as RoundPurposeType)
                    : false
            }
          />
          {filter.label}
        </label>
      </FilterItem>
    );
  }

  public render() {
    const { portfolioReportStore } = this.store;
    const TriggerComponent = (
      <TriggerButton>
        <TriggerButtonIcon>
          <kz-icon-filter size={16} />
        </TriggerButtonIcon>
        {Filters.map(filter => {
          if (
            portfolioReportStore.targetDeviceFilters.includes(filter.id as TargetDeviceType) ||
            portfolioReportStore.stateFilters.includes(filter.id as ExperienceStateType) ||
            portfolioReportStore.roundPurposeFilters.includes(filter.id as RoundPurposeType)
          ) {
            return <CurrentFilter key={filter.id}>{filter.label}</CurrentFilter>;
          }
        })}
      </TriggerButton>
    );
    const Items: IDropdownItem[] = Filters.map(filter => {
      return {
        key: `filter_${filter.id}`,
        component: this.createFilterItemComponent(filter),
      };
    });

    return (
      <Dropdown
        placement={'bottom-start'}
        triggerComponent={TriggerComponent}
        items={Items}
        onChange={this.stopPropagation}
        closeOnSelectItem={false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/FilterMenu.tsx